import React from 'react';
import { ShieldCheck, Leaf, Star, MapPin } from 'lucide-react';
const stats = [{
  icon: <ShieldCheck size={32} data-id="element-242" />,
  label: 'Cage-Free Always',
  desc: 'No kennels, no stress'
}, {
  icon: <Leaf size={32} data-id="element-243" />,
  label: 'Eco-Friendly Products',
  desc: 'Gentle on skin & coats'
}, {
  icon: <Star size={32} data-id="element-244" />,
  label: '3,000+ Happy Clients',
  desc: '5-star rated service'
}, {
  icon: <MapPin size={32} data-id="element-245" />,
  label: 'Mobile + Salon',
  desc: 'We come to you or visit us'
}];
export function WhyChooseUs() {
  return <section className="bg-gradient-to-r from-brand-orange to-[#FF8C33] py-16 text-brand-light" data-id="element-246">
      <div className="container mx-auto px-6 md:px-12" data-id="element-247">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-4 text-center" data-id="element-248">
          {stats.map((stat, index) => <div key={index} className="flex flex-col items-center group" data-id="element-249">
              <div className="mb-4 text-brand-light/90 group-hover:scale-110 group-hover:text-white transition-transform duration-300" data-id="element-250">
                {stat.icon}
              </div>
              <h4 className="text-xl font-heading mb-1" data-id="element-251">{stat.label}</h4>
              <p className="text-sm text-brand-light/80" data-id="element-252">{stat.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}